import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';

// Context
import { AuthProvider } from './context/AuthContext';
import { SystemProvider } from './context/SystemContext';
import { FireControllerProvider } from './context/FireControllerContext';
import { ToastProvider } from './context/ToastContext';

// Config
import KEYCLOAK_CONFIG from './config/keycloakConfig';

// AppContent component
import AppContent from './AppContent';

// Components
import CookieConsentBanner from './components/CookieConsentBanner/CookieConsentBanner';

/**
 * Main App component - Root component that provides authentication and system context
 * AuthProvider wraps SystemProvider to make authentication available to all components
 * @returns {JSX.Element} The rendered application with auth and system context
 */
function App() {
  return (
    <Router>
      <AuthProvider config={KEYCLOAK_CONFIG}>
        <FireControllerProvider>
          <SystemProvider>
            <ToastProvider>
              <AppContent />
              <CookieConsentBanner />
            </ToastProvider>
          </SystemProvider>
        </FireControllerProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;